import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { _EmployeeBenefit } from "../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { Modal } from "../../../theme/Component/Modal";
import useModal, { MODAL_LG } from "../../../theme/Component/hooks/useModal";
import { EmployeeBenefit } from "./EmployeeBenefit";

interface Props {
    label?: string;
    idSelector: number;
    onChange: (value: any) => void;
    disabled?: boolean;
}

export const EmployeeBenefitEditor = ({ idSelector, label, onChange, disabled }: Props) => {
    const { instance } = useDataBean(_EmployeeBenefit);
    const modal = useModal("Tipos de Beneficios de Empleados", MODAL_LG);

    const [valor, setValor] = useState("");
    const [bean, setBean] = useState<any>({});
    const [obj, setObj] = useState<any>({});

    const getProperties = (item: any) => {
        return item?.DataBeanProperties ?? item ?? {};
    };

    const getCountryLabel = (item: any) => {
        const data = getProperties(item);
        return [data.CountryISO3, data.CountryName].filter(Boolean).join(" - ");
    };

    const getDisplayValue = (item: any) => {
        const data = getProperties(item);

        if (!data?.IDEmployeeBenefit && !data?.Name) {
            return "";
        }

        return `${data.Mnemonic ?? data.IDEmployeeBenefit ?? ""} - ${data.Name ?? ""}`;
    };

    const getLocalClassProperty = () => {
        return bean?.LocalClassForName !== undefined && bean?.LocalCassForName === undefined
            ? "LocalClassForName"
            : "LocalCassForName";
    };

    useEffect(() => {
        if (idSelector) {
            getItem();
        } else {
            setValor("");
            setBean({});
            setObj({});
        }
    }, [idSelector]);

    const getItem = () => {
        instance.getEmployeeBenefit(idSelector).then((resp: any) => {
            const data = getProperties(resp);
            setBean(data);
            setObj(data);
            setValor(getDisplayValue(data));
            onChange(data);
        }).catch(() => {
            toast.error("Beneficio de empleado no encontrado");
            setValor("");
            setBean({});
            setObj({});
        });
    };

    const returnValue = () => {
        const data = getProperties(obj);

        if (data?.IDEmployeeBenefit) {
            setBean(data);
            setValor(getDisplayValue(data));
            modal.close();
            onChange(data);
        } else {
            toast.error("Beneficio de empleado no valido");
        }
    };

    const updateItem = () => {
        if (!bean?.IDEmployeeBenefit) {
            toast.error("Debe seleccionar un beneficio de empleado");
            return;
        }

        const { Country, ...dataToUpdate } = bean;

        instance.updateEmployeeBenefit(dataToUpdate).then((resp: any) => {
            const data = Object.keys(getProperties(resp)).length > 0 ? getProperties(resp) : dataToUpdate;
            setBean(data);
            setObj(data);
            setValor(getDisplayValue(data));
            onChange(data);
            toast.success("Beneficio de empleado actualizado");
        }).catch((err: any) => {
            toast.error(err);
        });
    };

    const localClassProperty = getLocalClassProperty();

    return (
        <>
            {label && label !== " " && (
                <label>{label ?? "Seleccione un beneficio de empleado"}</label>
            )}

            <div
                className={`form-control text-wrap ${disabled ? "bg-light text-muted" : "cursor-pointer"}`}
                style={{ minHeight: "35px" }}
                onClick={() => {
                    if (!disabled) {
                        modal.open();
                    }
                }}
            >
                {valor ? valor : <span>Seleccionar...</span>}
            </div>

            <Modal
                onSubmitLabel="Seleccionar"
                modal={modal.modal}
                updateModal={modal.setModal}
                eventModal={returnValue}
            >
                <EmployeeBenefit
                    isModal
                    _onChange={(e: any) => {
                        setObj(e);
                    }}
                />
            </Modal>
        </>
    );
};
